import { logger } from "../utils";

export class SafeSessionStorageService {
  private static maybeInstance?: SafeSessionStorageService;
  private static storage: Map<string, string> = new Map();

  static getInstance() {
    if (!SafeSessionStorageService.maybeInstance) {
      return new SafeSessionStorageService();
    }

    return SafeSessionStorageService.maybeInstance;
  }

  setItem(key: string, value: string) {
    try {
      logger.debug("trying to set", key, value);
      sessionStorage.setItem(key, value);
    } catch (e) {
      logger.warn(`Couldn't set ${key} in session storage: `, e, "saving locally");
      SafeSessionStorageService.storage.set(key, value);
    }
  }

  getItem(key: string): string | null | undefined {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      logger.warn(
        `Couldn't retrieve ${key} from session storage: `,
        e,
        "trying to retrieve locally"
      );
      return SafeSessionStorageService.storage.get(key);
    }
  }
}
